const byteLimit = 20000000

const initFileListener = () => {
    if (document.querySelectorAll('input[type="file"]').length > 0) {
        let fileInputs = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>
        
        if (fileInputs.length > 0) {
            fileInputs.forEach(input => {
                input.addEventListener('change', () => {
                    let fileInputsList = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>
                    updateFileList(input)
                    checkFileSize(fileInputsList)
                })
            })
        }
    }
}

const updateFileList = (input: HTMLInputElement) => {
    let parentEl = input.parentElement
    
    if (parentEl)
    {
        let listContainer = parentEl.querySelector('.fileupload__info') as HTMLElement
        let filesList = parentEl.querySelector('.fileupload__info__list') as HTMLElement
        let inputFiles = Array.from(input.files) as File[]

        if (listContainer && filesList)
        {
            listContainer.style.display = 'none'
            filesList.innerHTML = ''

            if (inputFiles.length > 0)
            {
                listContainer.style.display = 'block'

                inputFiles.forEach(file => {
                    let li = document.createElement('li')
                    li.innerText = file.name + ' (' + (file.size/1000000).toFixed(1) + 'MB)'
                    filesList.appendChild(li)
                })

                // if (!listContainer.querySelector('.fileupload__info__clear-files')) {
                //     let clearFilesButton = document.createElement('button')
                //     clearFilesButton.type = 'button'
                //     clearFilesButton.className = 'fileupload__info__clear-files'
                //     clearFilesButton.innerText = 'Ta bort filer'
                //     clearFilesButton.addEventListener('click' , () => {
                //         input.value = ''
                //         listContainer.style.display = 'none'
                //         filesList.innerHTML = ''

                //         let fileInputsList = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>
                //         checkFileSize(fileInputsList)
                //     })

                //     listContainer.appendChild(clearFilesButton)
                // }
            }
        }
    }
}

const checkFileSize = (fileInputs: NodeListOf<HTMLInputElement>) => {
    let valid = false
    let allFiles = new Array<File>()

    fileInputs.forEach(input => {
        if (input.files.length > 0) {
            let fileArray = Array.from(input.files)

            fileArray.forEach(file => {
                allFiles.push(file)
            })
        }
    })

    let fileBytes = 0

    if (allFiles.length > 0) {
        allFiles.forEach(f => {
            fileBytes += f.size
        })
    }

    valid = fileBytes < byteLimit

    let form = fileInputs.item(0).closest('form') as HTMLFormElement
    let submit = form.querySelector('input[type="submit"]') as HTMLInputElement

    if (!valid) {
        if (submit) submit.disabled = true

        if (form && !document.querySelector('#file-too-large')) {
            const errorMessageContainer = document.createElement('p')
            const errorMessage = 'Detta formulär kan ta emot max 20MB. Vänligen välj andra filer.'
            errorMessageContainer.id = 'file-too-large'
            errorMessageContainer.className = 'field-validation-error'
            errorMessageContainer.innerText = errorMessage
    
            form.appendChild(errorMessageContainer)
            form.ariaInvalid = 'true'
            form.ariaErrorMessage = errorMessage
        }
    } else {
        if (form.querySelector('#file-too-large')) form.removeChild(document.querySelector('#file-too-large'))
        if (submit) submit.disabled = false
        if (form) {
            form.ariaInvalid = 'false'
            form.ariaErrorMessage = ''
        } 
    }

    console.log('all files', allFiles)
}

/*
    Byte limit = 20000000
    Check total bytes, if over byte limit, don't allow submission and add error message
*/

export function initForms() {
    initFileListener()
}